export const childGenderMaster: Array<{ value: string; label: string }> = [
    { value: '1', label: '男' },
    { value: '2', label: '女' },
    { value: '99', label: '回答しない' },
];
